import { ApiSet, BaseResponse, IndexApiSet, useDeleteApi, useIndexApi, usePostApi, usePutApi } from 'utils/network/api_hooks'
import { Form, useEffectSkipFirst } from 'utils/hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { PagingResponse } from 'entities'
import { TrainingLedger, TrainingLedgerForm, TrainingLedgerSearchForm } from 'entities/training_ledger'

type TrainingLedgerResponse = PagingResponse & {
    results: TrainingLedger[]
}

export function useFetchTrainingLedgerApi(searchForm?: Form<TrainingLedgerSearchForm>): IndexApiSet<TrainingLedgerResponse> & { execute: () => void } {
    const apiPath = 'training_ledgers/'
    const api = useIndexApi<TrainingLedgerResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
    })

    const execute = (): void => {
        api.execute(apiPath, { params: searchForm?.object })
    }

    useEffectSkipFirst(() => {
        execute()
    }, [api.pageSet.page, api.pageSet.perPage])

    useEffectSkipFirst(() => {
        execute()
    }, [searchForm?.object])

    return { ...api, execute: execute }
}

export function usePostTrainingLedgerApi(): ApiSet<BaseResponse> & { execute: (form: Form<TrainingLedgerForm>) => void } {
    const apiSet = usePostApi<BaseResponse, TrainingLedgerForm>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<TrainingLedgerForm>) => {
        const apiPath = `training_ledgers/`
        apiSet.execute(apiPath, form)
    }

    return { ...apiSet, execute: execute }
}

export function usePutTrainingLedgerApi(): ApiSet<BaseResponse> & { execute: (form: Form<TrainingLedgerForm>) => void } {
    const apiSet = usePutApi<BaseResponse, TrainingLedgerForm>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<TrainingLedgerForm>) => {
        const apiPath = `training_ledgers/${form.object.id}/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}

export function useBulkPutTrainingLedgerApi(): ApiSet<BaseResponse> & { execute: (form: Form<TrainingLedgerForm[]>) => void } {
    const apiSet = usePutApi<BaseResponse, TrainingLedgerForm[]>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<TrainingLedgerForm[]>) => {
        const apiPath = `training_ledgers/bulk_update/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}

export function useDeleteTrainingLedgerApi(): ApiSet<BaseResponse> & {
    execute: (id: number) => void
} {
    const api = useDeleteApi<BaseResponse>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (id: number): void => {
        const apiPath = `training_ledgers/${id}/`
        api.execute(apiPath)
    }

    return { ...api, execute: execute }
}
